import { useState } from "react";

import { Button, Icon, Intent } from "@blueprintjs/core";
import { useLocation } from "react-router";

import {
  CalculatorState,
  serializeStateToParams,
} from "@/components/pages_public/sales-comp/utils/shareUtils";

import { SharePopover } from "./SharePopover";

interface ShareButtonProps {
  calculatorState: Partial<CalculatorState>;
}

function ShareButton({ calculatorState }: ShareButtonProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const location = useLocation();

  // Generate share URL using react-router's location instead of window directly
  const generateShareUrl = (): string => {
    // Safe guard for SSR
    if (typeof window === "undefined") {
      return "";
    }

    const baseUrl = window.location.origin + location.pathname;
    const params = serializeStateToParams(calculatorState);

    return params ? `${baseUrl}?${params}` : baseUrl;
  };

  const shareUrl = generateShareUrl();

  return (
    <SharePopover
      isOpen={isPopoverOpen}
      onClose={() => setIsPopoverOpen(false)}
      shareUrl={shareUrl}
      target={
        <Button
          intent={Intent.PRIMARY}
          icon={<Icon icon="share" />}
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        >
          Share
        </Button>
      }
    />
  );
}

export default ShareButton;
